/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateMyModelProviderSecretBody
} from './model/createMyModelProviderSecretBody.js';

import type {
  CreateMySecretBody
} from './model/createMySecretBody.js';

import type {
  CreatePersonalApiKey201
} from './model/createPersonalApiKey201.js';

import type {
  CreatePersonalApiKeyBody
} from './model/createPersonalApiKeyBody.js';

import type {
  DeleteMyCredentialParams
} from './model/deleteMyCredentialParams.js';

import type {
  GetMyCredentialStatus200
} from './model/getMyCredentialStatus200.js';

import type {
  GetMyCredentialStatusParams
} from './model/getMyCredentialStatusParams.js';

import type {
  ListAccessibleModelProviderSecrets200
} from './model/listAccessibleModelProviderSecrets200.js';

import type {
  ListAccessibleModelProviderSecretsParams
} from './model/listAccessibleModelProviderSecretsParams.js';

import type {
  ListMyCredentials200
} from './model/listMyCredentials200.js';

import type {
  ListMyModelProviderSecrets200
} from './model/listMyModelProviderSecrets200.js';

import type {
  ListMySecrets200
} from './model/listMySecrets200.js';

import type {
  ListPersonalApiKeys200
} from './model/listPersonalApiKeys200.js';

import type {
  ModelProviderSecret
} from './model/modelProviderSecret.js';

import type {
  RegisterClaudeMaxCredential201
} from './model/registerClaudeMaxCredential201.js';

import type {
  RegisterClaudeMaxCredentialBody
} from './model/registerClaudeMaxCredentialBody.js';

import type {
  RegisterCodexSubscriptionCredential201
} from './model/registerCodexSubscriptionCredential201.js';

import type {
  RegisterCodexSubscriptionCredentialBody
} from './model/registerCodexSubscriptionCredentialBody.js';

import type {
  ScopedSecret
} from './model/scopedSecret.js';

import type {
  UpdateMyModelProviderSecretBody
} from './model/updateMyModelProviderSecretBody.js';

import type {
  UpdateMySecretBody
} from './model/updateMySecretBody.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List the current user's personal API keys.
 */
export const listPersonalApiKeys = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListPersonalApiKeys200>(
      {url: `/me/api-keys`, method: 'GET', signal
    },
      options);
    }




export const getListPersonalApiKeysQueryKey = () => {
    return [
    `/me/api-keys`
    ] as const;
    }


export const getListPersonalApiKeysQueryOptions = <TData = Awaited<ReturnType<typeof listPersonalApiKeys>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPersonalApiKeys>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPersonalApiKeysQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPersonalApiKeys>>> = ({ signal }) => listPersonalApiKeys(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPersonalApiKeys>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPersonalApiKeysQueryResult = NonNullable<Awaited<ReturnType<typeof listPersonalApiKeys>>>
export type ListPersonalApiKeysQueryError = unknown


/**
 * @summary List the current user's personal API keys.
 */

export function useListPersonalApiKeys<TData = Awaited<ReturnType<typeof listPersonalApiKeys>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPersonalApiKeys>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPersonalApiKeysQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The plaintext token is returned once in this response and can never be retrieved again.
 * @summary Create a personal API key.
 */
export const createPersonalApiKey = (
    createPersonalApiKeyBody: CreatePersonalApiKeyBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<CreatePersonalApiKey201>(
      {url: `/me/api-keys`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPersonalApiKeyBody, signal
    },
      options);
    }




export const getCreatePersonalApiKeyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPersonalApiKey>>, TError,{data: CreatePersonalApiKeyBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPersonalApiKey>>, TError,{data: CreatePersonalApiKeyBody}, TContext> => {

const mutationKey = ['createPersonalApiKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPersonalApiKey>>, {data: CreatePersonalApiKeyBody}> = (props) => {
          const {data} = props ?? {};

          return  createPersonalApiKey(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePersonalApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof createPersonalApiKey>>>
    export type CreatePersonalApiKeyMutationBody = CreatePersonalApiKeyBody
    export type CreatePersonalApiKeyMutationError = unknown

    /**
 * @summary Create a personal API key.
 */
export const useCreatePersonalApiKey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPersonalApiKey>>, TError,{data: CreatePersonalApiKeyBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPersonalApiKey>>,
        TError,
        {data: CreatePersonalApiKeyBody},
        TContext
      > => {
      return useMutation(getCreatePersonalApiKeyMutationOptions(options));
    }
    /**
 * @summary Revoke a personal API key.
 */
export const revokePersonalApiKey = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/me/api-keys/${encodeURIComponent(String(id))}`, method: 'DELETE', signal
    },
      options);
    }




export const getRevokePersonalApiKeyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokePersonalApiKey>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokePersonalApiKey>>, TError,{id: string}, TContext> => {

const mutationKey = ['revokePersonalApiKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokePersonalApiKey>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  revokePersonalApiKey(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokePersonalApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof revokePersonalApiKey>>>

    export type RevokePersonalApiKeyMutationError = unknown

    /**
 * @summary Revoke a personal API key.
 */
export const useRevokePersonalApiKey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokePersonalApiKey>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokePersonalApiKey>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRevokePersonalApiKeyMutationOptions(options));
    }
    /**
 * @summary List current user credentials
 */
export const listMyCredentials = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListMyCredentials200>(
      {url: `/me/credentials`, method: 'GET', signal
    },
      options);
    }




export const getListMyCredentialsQueryKey = () => {
    return [
    `/me/credentials`
    ] as const;
    }


export const getListMyCredentialsQueryOptions = <TData = Awaited<ReturnType<typeof listMyCredentials>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyCredentials>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyCredentialsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyCredentials>>> = ({ signal }) => listMyCredentials(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyCredentials>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMyCredentialsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyCredentials>>>
export type ListMyCredentialsQueryError = unknown


/**
 * @summary List current user credentials
 */

export function useListMyCredentials<TData = Awaited<ReturnType<typeof listMyCredentials>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyCredentials>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMyCredentialsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Delete a current user credential
 */
export const deleteMyCredential = (
    kind: 'claude-max' | 'codex-subscription',
    params?: DeleteMyCredentialParams,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/me/credentials/${encodeURIComponent(String(kind))}`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteMyCredentialMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMyCredential>>, TError,{kind: 'claude-max' | 'codex-subscription';params?: DeleteMyCredentialParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMyCredential>>, TError,{kind: 'claude-max' | 'codex-subscription';params?: DeleteMyCredentialParams}, TContext> => {

const mutationKey = ['deleteMyCredential'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMyCredential>>, {kind: 'claude-max' | 'codex-subscription';params?: DeleteMyCredentialParams}> = (props) => {
          const {kind,params} = props ?? {};

          return  deleteMyCredential(kind,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMyCredentialMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMyCredential>>>

    export type DeleteMyCredentialMutationError = unknown

    /**
 * @summary Delete a current user credential
 */
export const useDeleteMyCredential = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMyCredential>>, TError,{kind: 'claude-max' | 'codex-subscription';params?: DeleteMyCredentialParams}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteMyCredential>>,
        TError,
        {kind: 'claude-max' | 'codex-subscription';params?: DeleteMyCredentialParams},
        TContext
      > => {
      return useMutation(getDeleteMyCredentialMutationOptions(options));
    }
    /**
 * @summary Get current user credential status
 */
export const getMyCredentialStatus = (
    kind: 'claude-max' | 'codex-subscription',
    params?: GetMyCredentialStatusParams,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<GetMyCredentialStatus200>(
      {url: `/me/credentials/${encodeURIComponent(String(kind))}/status`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetMyCredentialStatusQueryKey = (kind: 'claude-max' | 'codex-subscription',
    params?: GetMyCredentialStatusParams,) => {
    return [
    `/me/credentials/${kind}/status`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMyCredentialStatusQueryOptions = <TData = Awaited<ReturnType<typeof getMyCredentialStatus>>, TError = unknown>(kind: 'claude-max' | 'codex-subscription',
    params?: GetMyCredentialStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyCredentialStatus>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyCredentialStatusQueryKey(kind,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCredentialStatus>>> = ({ signal }) => getMyCredentialStatus(kind,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyCredentialStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyCredentialStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getMyCredentialStatus>>>
export type GetMyCredentialStatusQueryError = unknown


/**
 * @summary Get current user credential status
 */

export function useGetMyCredentialStatus<TData = Awaited<ReturnType<typeof getMyCredentialStatus>>, TError = unknown>(
 kind: 'claude-max' | 'codex-subscription',
    params?: GetMyCredentialStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyCredentialStatus>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyCredentialStatusQueryOptions(kind,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Register a Claude Max credential
 */
export const registerClaudeMaxCredential = (
    registerClaudeMaxCredentialBody: RegisterClaudeMaxCredentialBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<RegisterClaudeMaxCredential201>(
      {url: `/me/credentials/claude-max`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerClaudeMaxCredentialBody, signal
    },
      options);
    }




export const getRegisterClaudeMaxCredentialMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerClaudeMaxCredential>>, TError,{data: RegisterClaudeMaxCredentialBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof registerClaudeMaxCredential>>, TError,{data: RegisterClaudeMaxCredentialBody}, TContext> => {

const mutationKey = ['registerClaudeMaxCredential'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerClaudeMaxCredential>>, {data: RegisterClaudeMaxCredentialBody}> = (props) => {
          const {data} = props ?? {};

          return  registerClaudeMaxCredential(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterClaudeMaxCredentialMutationResult = NonNullable<Awaited<ReturnType<typeof registerClaudeMaxCredential>>>
    export type RegisterClaudeMaxCredentialMutationBody = RegisterClaudeMaxCredentialBody
    export type RegisterClaudeMaxCredentialMutationError = unknown

    /**
 * @summary Register a Claude Max credential
 */
export const useRegisterClaudeMaxCredential = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerClaudeMaxCredential>>, TError,{data: RegisterClaudeMaxCredentialBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof registerClaudeMaxCredential>>,
        TError,
        {data: RegisterClaudeMaxCredentialBody},
        TContext
      > => {
      return useMutation(getRegisterClaudeMaxCredentialMutationOptions(options));
    }
    /**
 * @summary Register a Codex subscription credential
 */
export const registerCodexSubscriptionCredential = (
    registerCodexSubscriptionCredentialBody: RegisterCodexSubscriptionCredentialBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<RegisterCodexSubscriptionCredential201>(
      {url: `/me/credentials/codex-subscription`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerCodexSubscriptionCredentialBody, signal
    },
      options);
    }




export const getRegisterCodexSubscriptionCredentialMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerCodexSubscriptionCredential>>, TError,{data: RegisterCodexSubscriptionCredentialBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof registerCodexSubscriptionCredential>>, TError,{data: RegisterCodexSubscriptionCredentialBody}, TContext> => {

const mutationKey = ['registerCodexSubscriptionCredential'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerCodexSubscriptionCredential>>, {data: RegisterCodexSubscriptionCredentialBody}> = (props) => {
          const {data} = props ?? {};

          return  registerCodexSubscriptionCredential(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterCodexSubscriptionCredentialMutationResult = NonNullable<Awaited<ReturnType<typeof registerCodexSubscriptionCredential>>>
    export type RegisterCodexSubscriptionCredentialMutationBody = RegisterCodexSubscriptionCredentialBody
    export type RegisterCodexSubscriptionCredentialMutationError = unknown

    /**
 * @summary Register a Codex subscription credential
 */
export const useRegisterCodexSubscriptionCredential = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerCodexSubscriptionCredential>>, TError,{data: RegisterCodexSubscriptionCredentialBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof registerCodexSubscriptionCredential>>,
        TError,
        {data: RegisterCodexSubscriptionCredentialBody},
        TContext
      > => {
      return useMutation(getRegisterCodexSubscriptionCredentialMutationOptions(options));
    }
    /**
 * @summary List current user model provider secrets
 */
export const listMyModelProviderSecrets = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListMyModelProviderSecrets200>(
      {url: `/me/model-provider-secrets`, method: 'GET', signal
    },
      options);
    }




export const getListMyModelProviderSecretsQueryKey = () => {
    return [
    `/me/model-provider-secrets`
    ] as const;
    }


export const getListMyModelProviderSecretsQueryOptions = <TData = Awaited<ReturnType<typeof listMyModelProviderSecrets>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyModelProviderSecrets>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyModelProviderSecretsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyModelProviderSecrets>>> = ({ signal }) => listMyModelProviderSecrets(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyModelProviderSecrets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMyModelProviderSecretsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyModelProviderSecrets>>>
export type ListMyModelProviderSecretsQueryError = unknown


/**
 * @summary List current user model provider secrets
 */

export function useListMyModelProviderSecrets<TData = Awaited<ReturnType<typeof listMyModelProviderSecrets>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMyModelProviderSecrets>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMyModelProviderSecretsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Add a personal model provider key.
 */
export const createMyModelProviderSecret = (
    createMyModelProviderSecretBody: CreateMyModelProviderSecretBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ModelProviderSecret>(
      {url: `/me/model-provider-secrets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMyModelProviderSecretBody, signal
    },
      options);
    }




export const getCreateMyModelProviderSecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMyModelProviderSecret>>, TError,{data: CreateMyModelProviderSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMyModelProviderSecret>>, TError,{data: CreateMyModelProviderSecretBody}, TContext> => {

const mutationKey = ['createMyModelProviderSecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMyModelProviderSecret>>, {data: CreateMyModelProviderSecretBody}> = (props) => {
          const {data} = props ?? {};

          return  createMyModelProviderSecret(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMyModelProviderSecretMutationResult = NonNullable<Awaited<ReturnType<typeof createMyModelProviderSecret>>>
    export type CreateMyModelProviderSecretMutationBody = CreateMyModelProviderSecretBody
    export type CreateMyModelProviderSecretMutationError = unknown

    /**
 * @summary Add a personal model provider key.
 */
export const useCreateMyModelProviderSecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMyModelProviderSecret>>, TError,{data: CreateMyModelProviderSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createMyModelProviderSecret>>,
        TError,
        {data: CreateMyModelProviderSecretBody},
        TContext
      > => {
      return useMutation(getCreateMyModelProviderSecretMutationOptions(options));
    }
    /**
 * @summary Update a current user model provider secret
 */
export const updateMyModelProviderSecret = (
    id: string,
    updateMyModelProviderSecretBody: UpdateMyModelProviderSecretBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ModelProviderSecret>(
      {url: `/me/model-provider-secrets/${encodeURIComponent(String(id))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateMyModelProviderSecretBody, signal
    },
      options);
    }




export const getUpdateMyModelProviderSecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyModelProviderSecret>>, TError,{id: string;data: UpdateMyModelProviderSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMyModelProviderSecret>>, TError,{id: string;data: UpdateMyModelProviderSecretBody}, TContext> => {

const mutationKey = ['updateMyModelProviderSecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMyModelProviderSecret>>, {id: string;data: UpdateMyModelProviderSecretBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateMyModelProviderSecret(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMyModelProviderSecretMutationResult = NonNullable<Awaited<ReturnType<typeof updateMyModelProviderSecret>>>
    export type UpdateMyModelProviderSecretMutationBody = UpdateMyModelProviderSecretBody
    export type UpdateMyModelProviderSecretMutationError = unknown

    /**
 * @summary Update a current user model provider secret
 */
export const useUpdateMyModelProviderSecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMyModelProviderSecret>>, TError,{id: string;data: UpdateMyModelProviderSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMyModelProviderSecret>>,
        TError,
        {id: string;data: UpdateMyModelProviderSecretBody},
        TContext
      > => {
      return useMutation(getUpdateMyModelProviderSecretMutationOptions(options));
    }
    /**
 * @summary Delete a current user model provider secret
 */
export const deleteMyModelProviderSecret = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/me/model-provider-secrets/${encodeURIComponent(String(id))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteMyModelProviderSecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMyModelProviderSecret>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMyModelProviderSecret>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteMyModelProviderSecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMyModelProviderSecret>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteMyModelProviderSecret(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMyModelProviderSecretMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMyModelProviderSecret>>>

    export type DeleteMyModelProviderSecretMutationError = unknown

    /**
 * @summary Delete a current user model provider secret
 */
export const useDeleteMyModelProviderSecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMyModelProviderSecret>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteMyModelProviderSecret>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteMyModelProviderSecretMutationOptions(options));
    }
    /**
 * @summary List every model provider key the caller can use across user, team, and org scopes.
 */
export const listAccessibleModelProviderSecrets = (
    params?: ListAccessibleModelProviderSecretsParams,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListAccessibleModelProviderSecrets200>(
      {url: `/me/model-provider-secrets/accessible`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListAccessibleModelProviderSecretsQueryKey = (params?: ListAccessibleModelProviderSecretsParams,) => {
    return [
    `/me/model-provider-secrets/accessible`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAccessibleModelProviderSecretsQueryOptions = <TData = Awaited<ReturnType<typeof listAccessibleModelProviderSecrets>>, TError = unknown>(params?: ListAccessibleModelProviderSecretsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccessibleModelProviderSecrets>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAccessibleModelProviderSecretsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccessibleModelProviderSecrets>>> = ({ signal }) => listAccessibleModelProviderSecrets(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAccessibleModelProviderSecrets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAccessibleModelProviderSecretsQueryResult = NonNullable<Awaited<ReturnType<typeof listAccessibleModelProviderSecrets>>>
export type ListAccessibleModelProviderSecretsQueryError = unknown


/**
 * @summary List every model provider key the caller can use across user, team, and org scopes.
 */

export function useListAccessibleModelProviderSecrets<TData = Awaited<ReturnType<typeof listAccessibleModelProviderSecrets>>, TError = unknown>(
 params?: ListAccessibleModelProviderSecretsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAccessibleModelProviderSecrets>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAccessibleModelProviderSecretsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary List current user secrets
 */
export const listMySecrets = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListMySecrets200>(
      {url: `/me/secrets`, method: 'GET', signal
    },
      options);
    }




export const getListMySecretsQueryKey = () => {
    return [
    `/me/secrets`
    ] as const;
    }


export const getListMySecretsQueryOptions = <TData = Awaited<ReturnType<typeof listMySecrets>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMySecrets>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMySecretsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMySecrets>>> = ({ signal }) => listMySecrets(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMySecrets>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMySecretsQueryResult = NonNullable<Awaited<ReturnType<typeof listMySecrets>>>
export type ListMySecretsQueryError = unknown


/**
 * @summary List current user secrets
 */

export function useListMySecrets<TData = Awaited<ReturnType<typeof listMySecrets>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMySecrets>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMySecretsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create a current user secret
 */
export const createMySecret = (
    createMySecretBody: CreateMySecretBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ScopedSecret>(
      {url: `/me/secrets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMySecretBody, signal
    },
      options);
    }




export const getCreateMySecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMySecret>>, TError,{data: CreateMySecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMySecret>>, TError,{data: CreateMySecretBody}, TContext> => {

const mutationKey = ['createMySecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMySecret>>, {data: CreateMySecretBody}> = (props) => {
          const {data} = props ?? {};

          return  createMySecret(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMySecretMutationResult = NonNullable<Awaited<ReturnType<typeof createMySecret>>>
    export type CreateMySecretMutationBody = CreateMySecretBody
    export type CreateMySecretMutationError = unknown

    /**
 * @summary Create a current user secret
 */
export const useCreateMySecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMySecret>>, TError,{data: CreateMySecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createMySecret>>,
        TError,
        {data: CreateMySecretBody},
        TContext
      > => {
      return useMutation(getCreateMySecretMutationOptions(options));
    }
    /**
 * @summary Update a current user secret
 */
export const updateMySecret = (
    id: string,
    updateMySecretBody: UpdateMySecretBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ScopedSecret>(
      {url: `/me/secrets/${encodeURIComponent(String(id))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateMySecretBody, signal
    },
      options);
    }




export const getUpdateMySecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMySecret>>, TError,{id: string;data: UpdateMySecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMySecret>>, TError,{id: string;data: UpdateMySecretBody}, TContext> => {

const mutationKey = ['updateMySecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMySecret>>, {id: string;data: UpdateMySecretBody}> = (props) => {
          const {id,data} = props ?? {};

          return  updateMySecret(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMySecretMutationResult = NonNullable<Awaited<ReturnType<typeof updateMySecret>>>
    export type UpdateMySecretMutationBody = UpdateMySecretBody
    export type UpdateMySecretMutationError = unknown

    /**
 * @summary Update a current user secret
 */
export const useUpdateMySecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMySecret>>, TError,{id: string;data: UpdateMySecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMySecret>>,
        TError,
        {id: string;data: UpdateMySecretBody},
        TContext
      > => {
      return useMutation(getUpdateMySecretMutationOptions(options));
    }
    /**
 * @summary Delete a current user secret
 */
export const deleteMySecret = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/me/secrets/${encodeURIComponent(String(id))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteMySecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMySecret>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMySecret>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteMySecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMySecret>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteMySecret(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMySecretMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMySecret>>>

    export type DeleteMySecretMutationError = unknown

    /**
 * @summary Delete a current user secret
 */
export const useDeleteMySecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMySecret>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteMySecret>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteMySecretMutationOptions(options));
    }
